module.exports = __webpack_public_path__ + "img/otab-kreditering.4537a85b.jpg";